<template>
  <div>
    <van-nav-bar style="background-color: #42b983">
      <template #title>
        <span style="color: #ffffff">生成试用充值号</span>
      </template>
      <template #left>
        <router-link to="/my">
          <van-icon name="arrow-left" color="#ffffff"/>
          <span style="color: #ffffff">返回</span>
        </router-link>
      </template>
      <template #right>
        <router-link to="/">
          <van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/>
        </router-link>
      </template>
    </van-nav-bar>

    <van-cell-group>
      <van-cell>
        提示：如果用户完成了支付过程，但系统由于网络之类的原因无法确认用户支付的结果时，使用此功能进行人工确认。
        可以用微信订单好号或商户订单号
      </van-cell>

      <van-radio-group v-model="product_id">
        <van-cell-group>
          <van-cell v-for="product in products" :key="product.id" :title="product.title" clickable
                    @click="product_id = product.id">
            <template #title>
              {{ product.title }}-{{ product.amount }}元-{{ product.duration }}天
            </template>
            <template #right-icon>
              <van-radio :name="product.id"/>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>


      <van-cell>
        <van-field v-model="user_id" type="digit" label="目标用户ID:" label-width="120px"/>
      </van-cell>
      <van-cell>
        <van-field v-model="quantity" type="digit" label="充值号个数:" label-width="120px"/>
      </van-cell>
      <van-cell>
        <van-field v-model="remark" label="备注:" label-width="120px"/>
      </van-cell>
      <van-cell>
        <van-button type="info" block @click="addManger">提交生成</van-button>
      </van-cell>
    </van-cell-group>


    <!--    <van-dialog v-model="loading" title="" :show-confirm-button="false">-->
    <!--      <br>-->
    <!--      <van-loading size="50px" vertical>{{ loading_text }}</van-loading>-->
    <!--      <br>-->
    <!--    </van-dialog>-->

    <van-overlay :show="loading" style="display: flex;align-items: center;justify-content: center;height: 100%;">
      <van-loading size="24px" vertical>{{ loading_text }}</van-loading>
    </van-overlay>


  </div>
</template>

<script>
import copy from 'copy-to-clipboard';

export default {
  data() {
    return {
      product_id: 0,
      user_id: "",
      quantity: 1,
      remark: "",

      loading: false,
      loading_text: "生成中...",
      error: false,
      error_text: "",

      products: [],
      keys: [],
    };
  },
  created() {
    this.user_id = localStorage.getItem("user_id");
    this.getProducts();
  },
  methods: {
    getProducts() {
      this.products = [];
      this.$http.get("/wechat/products", {
        params: {
          form_type: 2,//充值卡号
          learn_type: 1,//1模拟考试;2课程学习
        }
      }).then(res => {
        console.log(res.data);
        if (200 === res.data.code) {
          this.products = res.data.data
        }
      });
    },

    addManger() {
      this.keys = [];
      this.loading = true;
      this.$http.post("/wechat/admin/create_cd_key", {
        product_id: this.product_id,
        user_id: parseInt(this.user_id),
        quantity: parseInt(this.quantity),
        remark: this.remark
      }).then(res => {
        this.user_id = ""
        this.quantity = 1
        this.product_id = 0
        this.remark = ""
        this.loading = false;
        if (200 !== res.data.code) {
          this.$toast.fail(res.data.msg);
          return
        }
        this.keys = res.data.data
        if (res.data.data.length>0){
          copy(res.data.data.join("\n"));
        }

        this.$toast.success("生成成功")
      });
    },
  }
}
</script>
